function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import Section from '../../../containers/organisms/Section';
import { Container } from './style';

var Dashboard =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dashboard, _React$Component);

  function Dashboard(_props) {
    var _this;

    _classCallCheck(this, Dashboard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dashboard).call(this, _props));

    _this.shouldComponentUpdate = function (nextProps) {
      if (_this.props.plots != nextProps.plots) return true;
      return false;
    };

    _this.render = function () {
      var props = _this.props;
      var plots = Object.keys(props.plots);

      if (plots && plots.length) {
        var sections = plots.map(function (id) {
          var plot = props.plots[id];
          var arr = ['demand_disaggregation', 'capacity_plant_resource', 'gen_time', 'fuel_price', 'market_price'];

          if (id == 'pred_scatter') {
            return React.createElement("section", {
              id: "graph-section-".concat(id),
              key: "graph-section-".concat(id)
            }, React.createElement(Section, {
              type: 'scatter',
              height: '850px',
              plotID: id,
              countryID: 'ni',
              plot: plot
            }));
          }

          if (id == 'energy_per_unit') {
            return React.createElement("section", {
              id: "graph-section-".concat(id),
              key: "graph-section-".concat(id)
            }, React.createElement(Section, {
              type: 'bar',
              height: '450px',
              format: 'column',
              plotID: id,
              countryID: 'ni',
              plot: plot
            }));
          }

          if (id == 'gen_map_time') {
            return React.createElement("section", {
              id: "graph-section-".concat(id),
              key: "graph-section-".concat(id)
            }, React.createElement(Section, {
              type: 'map',
              height: '650px',
              format: 'column',
              plotID: id,
              countryID: 'ni',
              plot: plot
            }));
          }

          if (id == 'gen_type_bar') {
            return React.createElement("section", {
              id: "graph-section-".concat(id),
              key: "graph-section-".concat(id)
            }, React.createElement(Section, {
              type: 'bar',
              height: '650px',
              format: 'stacked',
              plotID: id,
              countryID: 'ni',
              plot: plot
            }));
          }

          if (id == 'gen_type_bar_yearly') {
            return React.createElement("section", {
              id: "graph-section-".concat(id),
              key: "graph-section-".concat(id)
            }, React.createElement(Section, {
              height: '600px',
              type: 'bar',
              format: 'grouped',
              plotID: id,
              countryID: 'ni',
              plot: plot
            }));
          }

          if (arr.includes(id)) {
            return React.createElement("section", {
              id: "graph-section-".concat(id),
              key: "graph-section-".concat(id)
            }, React.createElement(Section, {
              height: '715px',
              type: 'line',
              plotID: id,
              countryID: 'ni',
              plot: plot
            }));
          }
        });
        return React.createElement(Container, null, sections);
      }

      return React.createElement("div", null);
    };

    _this.state = {};
    return _this;
  }

  return Dashboard;
}(React.Component);

Dashboard.propTypes = {
  plots: PropTypes.object.isRequired
};
export default Dashboard;